import { ComponentRef, Injectable, Type } from "@angular/core";
import { Observable, Subject } from "rxjs";
const environment = { production: true };
import { DynamicComponentBaseComponent } from "../../components/dynamic-component-base/dynamic-component-base.component";
import { DynamicDirective } from "../../directives/dynamic/dynamic.directive";
import { DynamicComponentObject } from "../../interfaces/dynamic-component-object";

@Injectable()
export class DynamicService {
  private dynamicSubject: Subject<DynamicComponentObject> = new Subject();

  constructor() {}

  getDynamic(): Observable<DynamicComponentObject> {
    return this.dynamicSubject.asObservable();
  }

  setDynamic(val: DynamicComponentObject) {
    this.dynamicSubject.next(val);
  }

  dynamicComponentCreator(
    componentObj: DynamicComponentObject<Record<string, unknown>>,
    dynamic: DynamicDirective
  ): Observable<ComponentRef<DynamicComponentBaseComponent>> {
    return new Observable((ret) => {
      if (componentObj.module) {
        (<any>componentObj.module.import)
          .then((m: any) => {
            m[<any>componentObj.module?.module];
            const componentRef = this.dynamicComponentCreatorInit(
              componentObj.component,
              dynamic,
              componentObj?.data || null
            );
            ret.next(componentRef);
          })
          .catch((err: Error) => {
            console.warn(err);
          });
      } else {
        const componentRef = this.dynamicComponentCreatorInit(
          componentObj.component,
          dynamic,
          componentObj?.data || null
        );
        ret.next(componentRef);
      }
    });
  }

  private dynamicComponentCreatorInit(
    component: Type<DynamicComponentBaseComponent>,
    dynamic: DynamicDirective,
    data: { [key: string]: unknown } | null
  ) {
    const viewContainerRef = dynamic.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(component);
    if (!environment.production) {
      console.info("Created Component", componentRef);
    }

    if (data) {
      this.setComponentData(componentRef, data);
    }

    return componentRef;
  }

  private setComponentData(
    component: ComponentRef<DynamicComponentBaseComponent>,
    data: { [key: string]: unknown }
  ) {
    component.instance.data = data;
  }
}
